// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__bfoDI","activePage":"Pagination_activePage__JsSN0","ellipsis":"Pagination_ellipsis__lT8S3"};